<template>
    <a-modal width="65%" title="查看" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @cancel="onClose" :footer="null" wrap-class-name="single-spa-vue">

        <a-descriptions :column="1" bordered>

            <a-descriptions-item label="版权图标">
                <img-upload v-model:value="form.icon" :showList="true" disabled />
            </a-descriptions-item>
            <a-descriptions-item label="版权名称">{{ form.copyrightName }}</a-descriptions-item>
            <a-descriptions-item label="版权范围">
                <dict-render :dict-obj="dictObjs['copyright_scope']" :text="form.copyrightRange"></dict-render>
            </a-descriptions-item>

            <a-descriptions-item label="版权行业类型">
                <dict-render :dict-obj="dictObjs['projectType']" :text="form.copyrightType"
                             v-if="form.copyrightType"></dict-render>
            </a-descriptions-item>

            <a-descriptions-item label="版权号">{{form.versionCode}}</a-descriptions-item>

            <a-descriptions-item label="授权日期">{{form.firstPublishDate}}</a-descriptions-item>
            <a-descriptions-item label="创作完成时间">{{form.buildCompleteDate}}</a-descriptions-item>

            <a-descriptions-item label="授权方式">
                <dict-render :dict-obj="dictObjs['intellectualsubsidy_get']" :text="form.accredit"
                             v-if="form.accredit"></dict-render>
            </a-descriptions-item>


        </a-descriptions>
    </a-modal>
</template>

<script>
    import {formMixin, dictMixin} from "@/mixins";
    import DictRender from "@/components/other/DictRender";

    export default {
        name: "Detail",
        mixins: [formMixin, dictMixin],
        components: {DictRender},
        data() {
            return {
                dictNames: "projectType,intellectualsubsidy_get,copyright_scope",
                form: {
                    id: null,
                    brandName: null,
                    scopeApplication: null,
                    brandIndustryType: null,
                    rangeAnalysis: null,
                    firstTime:null,
                    auditTime: null,
                    abutmentPhone: null,
                    abutmentUserName: null,
                    abutmentStartTime: null,
                    abutmentEndTime: null,
                    serviceStatus: null,
                    isOpen: null,
                },
            }
        },
        methods: {
            onClose() {
                this.visible = false
                this.$emit("onCloseModel")
            },
        }
    }
</script>

<style scoped lang="less">

</style>
